import React, { useEffect } from 'react'
import { Flex, Tabs } from 'antd'
import { useNavigate, useLocation, Outlet, useParams } from 'react-router-dom'
import useOneStationStore from '@/stores/oneStation'
import useGlobalConfigStore from '@/stores/globalConfig'
import useMessage from '@/hooks/useMessage'
import formatDate from '@/utils/formatDate'
import { useTranslation } from 'react-i18next'

const StationTab: React.FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const { id } = useParams()
  const stationInit = useOneStationStore(state => state.stationInit)
  const station = useOneStationStore(state => state.station)
  const updateTime = useGlobalConfigStore(state => state.updateTime)
  const setInitFinished = useGlobalConfigStore(state => state.setInitFinished)
  const { message } = useMessage()

  // const oneStationStore = useOneStationStore()
  // useEffect(() => {
  //   console.log(oneStationStore)
  // }, [oneStationStore])

  useEffect(() => {
    if (id) {
      stationInit(Number(id)).catch((error: any) => {
        console.log(error)
        message.error(error.message || error.msg || error)
      })
    }
  }, [id])

  const items = [
    { key: 'main', label: t('menu.site') },
    { key: 'sitedetail', label: t('menu.info') },
    { key: 'chart', label: t('menu.chart') },
    { key: 'devicelist', label: t('menu.devices') },
    {
      key: 'message',
      label: t('menu.message'),
      //   label: (
      //     <Badge offset={[0, 0]} size="small" count={99} overflowCount={99}>
      //       Message
      //     </Badge>
      //   ),
    },
  ]

  const goPage = (key: string) => {
    navigate(key, { replace: false })
  }

  return (
    <div className='app-content'>
      <div className='app-header'>
        <div className='app-header-left'>
          <img
            style={{ cursor: 'pointer' }}
            className='logo'
            src='/assets/web/logo.svg'
            onClick={() => {
              setInitFinished(false)
              navigate('/sitelist')
            }}
          />
          <div className='su'></div>
          <div className='app-header-left-two'>
            <div className='app-header-left-top'>
              <span>
                {(station.status === 'C001' || station.status === 'C002') && <i className='yuan success'></i>}
                {station.status === 'C003' && <i className='yuan warning'></i>}
                {station.status === 'C004' && <i className='yuan offline'></i>}
                {station.status === 'C005' && <i className='yuan fault'></i>}
                {station.station_name}
                {/* <Popover placement="bottom" content={<PopStation />}>
                  <img className="next" src="/assets/web/next.svg" />
                </Popover> */}
                <Flex align='center'>
                  <img className='ref' src='/assets/web/ref.svg' />
                  {/* <Link to="/setting" target="_blank">
                    <img className="ref" src="/assets/web/set.svg" style={{ marginTop: "-1px" }} />
                  </Link> */}
                </Flex>
              </span>
            </div>
            <div className='app-header-left-bottom'>
              {t('common.updateTime')}:&nbsp;{formatDate(updateTime)}{' '}
            </div>
          </div>
        </div>
        <div className='app-header-right'>
          <Tabs
            style={{ width: '500px' }}
            activeKey={pathname.split('/')[3] === 'inverter' ? 'devicelist' : pathname.split('/')[3]}
            size='large'
            onChange={goPage}
            items={items}
          />
        </div>
      </div>
      <div style={{ height: 'calc(100% - 74px)', padding: '15px' }}>
        <Outlet />
      </div>
    </div>
  )
}

export default StationTab

// const PopStation: React.FC = () => {
//   const test = [1, 2]
//   return (
//     <div className="PopStation">
//       {test.map((v) => (
//         <Row align={"middle"} gutter={10} key={v}>
//           <Col span={7}>
//             <img src="/assets/web/defalutStation.png" style={{ borderRadius: "2px" }} />
//           </Col>
//           <Col span={17}>
//             <span className="PopStationName">Station Name</span>
//           </Col>
//         </Row>
//       ))}
//     </div>
//   )
// }
